export default __webpack_public_path__ + "static/media/step_01.fd57ceb2.png";